module.exports = __webpack_public_path__ + "static/media/success.d1b8ca75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/success.svg
// module id = 2096
// module chunks = 0